// City-level data — used by RachatVille.jsx template. Each entry backs a
// unique long-tail SEO page at /rachat-voiture-a-{slug}.

export const VILLES = {
    lausanne: {
        slug: "lausanne",
        name: "Lausanne",
        cantonSlug: "vaud",
        cantonName: "Vaud",
        npa: ["1000", "1003", "1004", "1005", "1006", "1007", "1010", "1011", "1012", "1015"],
        quartiers: [
            "Centre-ville",
            "Chailly",
            "Ouchy",
            "Sébeillon",
            "Sous-Gare",
            "Prilly-Malley",
            "Vidy",
            "Bellevaux",
            "Vallée de la Jeunesse",
            "Cité",
        ],
        latitude: 46.5197,
        longitude: 6.6323,
        heroCarImageUrl:
            "https://images.unsplash.com/photo-1616422285623-13ff0162193c?w=1600&q=80&fm=webp&auto=format",
        heroAlt: "Rachat voiture à Lausanne — Capital Automobile, siège Ecublens",
        metaTitle:
            "Rachat voiture Lausanne — Cash en 24h | Capital Automobile",
        metaDescription:
            "Rachat de votre voiture cash en 24h à Lausanne (VD). Déplacement gratuit à Chailly, Ouchy, Prilly, Sébeillon et tout le canton. Évaluation gratuite.",
        localTrust:
            "Notre siège Capital Automobile est situé à Ecublens, à moins de 10 minutes de Lausanne — nous intervenons dans la journée à Sébeillon, Chailly, Ouchy, Bellevaux et tous les quartiers de la capitale vaudoise. Déplacement gratuit, offre ferme sous 24 heures.",
        miniFaq: [
            {
                q: "Combien de temps entre l'appel et l'offre pour un rachat à Lausanne ?",
                a: "Une estimation indicative en 5 minutes par téléphone au 076 442 58 04, une offre ferme sous 24h après votre demande en ligne, et une reprise sur place possible le jour même ou le lendemain — Lausanne est à moins de 10 minutes de notre siège d'Ecublens.",
            },
            {
                q: "Rachetez-vous à Prilly, Renens et Ecublens depuis votre siège lausannois ?",
                a: "Oui, gratuitement. Notre siège se trouve à Ecublens et l'ouest lausannois (Prilly, Renens, Chavannes, Bussigny) est notre zone la plus rapidement couverte : intervention souvent possible dans les deux heures.",
            },
            {
                q: "Prix moyen de rachat d'une voiture d'occasion à Lausanne en 2026 ?",
                a: "La fourchette moyenne pour un véhicule d'occasion en état correct racheté à Lausanne se situe entre 5 500 et 20 000 CHF selon marque, année et kilométrage. Les modèles premium allemands en bon état conservent une valeur nettement supérieure, en particulier lorsqu'ils sont bien entretenus.",
            },
            {
                q: "Puis-je vendre ma voiture à Lausanne le dimanche ou le soir ?",
                a: "Oui. Nous sommes joignables 7 jours sur 7 de 7h à 22h. Nous fixons régulièrement des rendez-vous à Lausanne en fin de journée ou le dimanche pour s'adapter aux horaires de nos clients.",
            },
        ],
    },
    "geneve-ville": {
        slug: "geneve-ville",
        name: "Genève",
        cantonSlug: "geneve",
        cantonName: "Genève",
        npa: ["1200", "1201", "1202", "1203", "1204", "1205", "1206", "1207", "1208", "1209"],
        quartiers: [
            "Rive-Gauche",
            "Rive-Droite",
            "Eaux-Vives",
            "Plainpalais",
            "Servette",
            "Pâquis",
            "Champel",
            "Petit-Saconnex",
            "Charmilles",
            "Saint-Jean",
        ],
        latitude: 46.2044,
        longitude: 6.1432,
        heroCarImageUrl:
            "https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=1600&q=80&fm=webp&auto=format",
        heroAlt: "Rachat voiture à Genève — Capital Automobile, spécialiste plaques GE",
        metaTitle:
            "Rachat voiture Genève — Cash en 24h | Capital Automobile",
        metaDescription:
            "Rachat de votre voiture cash en 24h à Genève (GE). Déplacement gratuit à Eaux-Vives, Plainpalais, Servette, Champel. Spécialiste plaques GE et export.",
        localTrust:
            "Nous nous déplaçons à Genève sous 24 heures dans tous les quartiers : Rive-Gauche, Rive-Droite, Eaux-Vives, Plainpalais, Servette, Champel. Notre équipe est spécialisée dans les plaques GE et gère toutes les procédures d'export pour les véhicules destinés à l'étranger.",
        miniFaq: [
            {
                q: "Combien de temps pour un rachat cash à Genève ?",
                a: "Offre ferme sous 24 heures après votre demande, et déplacement sur place possible dans les 24 à 48 heures. Le paiement est immédiat : cash sur place ou virement bancaire instantané le jour même.",
            },
            {
                q: "Rachetez-vous à Carouge, Vernier, Meyrin et Lancy ?",
                a: "Oui, gratuitement. Toute la couronne genevoise fait partie de notre zone standard : Carouge, Vernier, Meyrin, Onex, Lancy, Plan-les-Ouates, Thônex et Chêne-Bougeries incluses, sans surcoût.",
            },
            {
                q: "Vous gérez les plaques GE et la désimmatriculation cantonale ?",
                a: "Oui, c'est l'une de nos spécialités à Genève. Nous prenons en charge la procédure auprès du Service cantonal des véhicules (OCV) et gérons également les formalités d'export lorsque le véhicule est destiné à quitter la Suisse.",
            },
            {
                q: "Rachetez-vous les voitures des frontaliers habitant en France voisine ?",
                a: "Oui, nous rachetons couramment des véhicules avec plaques genevoises appartenant à des frontaliers. Nous vérifions la conformité au préalable et adaptons nos rendez-vous à leurs horaires — pause déjeuner, soirée ou week-end.",
            },
        ],
    },
};

export const VILLE_SLUGS = Object.keys(VILLES);

export function villesInCanton(cantonSlug) {
    return VILLE_SLUGS
        .map((s) => VILLES[s])
        .filter((v) => v.cantonSlug === cantonSlug);
}
